import { render, staticRenderFns } from "./UploadImgAttribute.vue?vue&type=template&id=2c5c1151&scoped=true&"
import script from "./UploadImgAttribute.vue?vue&type=script&lang=js&"
export * from "./UploadImgAttribute.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgAttribute.vue?vue&type=style&index=0&id=2c5c1151&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c1151",
  null
  
)

export default component.exports